// Mock data for Trello clone

export const mockBoards = [
  {
    id: 'board-1',
    title: 'Project Management',
    color: '#0079bf',
    starred: true,
    lists: [
      {
        id: 'list-1',
        title: 'To Do',
        boardId: 'board-1',
        cards: [
          {
            id: 'card-1',
            title: 'Design login page',
            description: 'Create wireframes and mockups for the login page',
            labels: ['Design', 'High Priority'],
            dueDate: '2024-01-15',
            members: ['Alice', 'Bob'],
            listId: 'list-1'
          },
          {
            id: 'card-2',
            title: 'Set up database',
            description: 'Configure MongoDB connection and basic schemas',
            labels: ['Backend'],
            members: ['Charlie'],
            listId: 'list-1'
          }
        ]
      },
      {
        id: 'list-2',
        title: 'In Progress',
        boardId: 'board-1',
        cards: [
          {
            id: 'card-3',
            title: 'Implement user authentication',
            description: 'Add JWT authentication with login/register functionality',
            labels: ['Backend', 'Medium Priority'],
            members: ['Alice'],
            listId: 'list-2'
          }
        ]
      },
      {
        id: 'list-3',
        title: 'Done',
        boardId: 'board-1',
        cards: [
          {
            id: 'card-4',
            title: 'Project setup',
            description: 'Initialize React app and FastAPI backend',
            labels: ['Setup'],
            members: ['Alice', 'Bob', 'Charlie'],
            listId: 'list-3'
          }
        ]
      }
    ]
  },
  {
    id: 'board-2',
    title: 'Marketing Campaign',
    color: '#d29034',
    starred: false,
    lists: [
      {
        id: 'list-4',
        title: 'Ideas',
        boardId: 'board-2',
        cards: [
          {
            id: 'card-5',
            title: 'Social media strategy',
            description: 'Plan content calendar for social media platforms',
            labels: ['Marketing'],
            members: ['Diana'],
            listId: 'list-4'
          }
        ]
      },
      {
        id: 'list-5',
        title: 'Execution',
        boardId: 'board-2',
        cards: []
      }
    ]
  }
];

export const mockUser = {
  id: 'user-1',
  name: 'John Doe',
  email: 'john@example.com',
  avatar: 'https://ui-avatars.com/api/?name=John+Doe&background=0079bf&color=fff'
};

export const labelColors = [
  '#61bd4f', // green
  '#f2d600', // yellow  
  '#ff9f1a', // orange
  '#eb5a46', // red
  '#c377e0', // purple
  '#0079bf', // blue
  '#00c2e0', // light blue
  '#51e898', // light green
  '#ff78cb', // pink
  '#344563'  // dark gray
];

export const boardColors = [
  '#4FC3F7', // light sky blue
  '#FFB74D', // light orange/peach  
  '#81C784', // soft green
  '#F06292', // soft coral/pink
  '#BA68C8', // light purple
  '#FF8A65', // soft salmon
  '#AED581', // light lime green
  '#4DD0E1', // light cyan
  '#A5D6A7'  // pale green
];